import { h, Fragment } from 'preact';
import parse from 'html-react-parser';
import { useEffect, useState, useRef } from 'preact/hooks';

import './yotpo-rewards.css';

const Rewards = () => {
  // Initialize product data and customer details once
  const productDataElement = document.getElementById('product-data');
  const { yotpoRewardsMarkup, customer, productPointsBlock } = JSON.parse(productDataElement?.innerHTML || '{}');
  const customerTags = customer?.tags?.find((tag) => tag.startsWith('swell_vip_'));
  const [swellAPI, setSwellAPI] = useState(null);
  const [rewardsElement, setRewardsElement] = useState(null);
  const containerRef = useRef(null); // Use useRef for the container

  if (!productPointsBlock && !yotpoRewardsMarkup) return null;

  useEffect(() => {
    containerRef.current = document.querySelector('.yotpo-product-point-widget-instance');

    if (!window.yotpoWidgetsContainer || !containerRef.current) return;

    // Initialize Yotpo widgets
    window.yotpoWidgetsContainer.initWidget(productPointsBlock?.instanceId, containerRef.current);

    if (!customer?.tags) return;

    // Async function to wait for swellAPI
    const initializeSwell = async () => {
      try {
        const waitForSwell = () => new Promise((resolve) => {
          const interval = setInterval(() => {
            if (window.swellAPI) {
              clearInterval(interval);
              resolve();
            }
          }, 100);
        });

        await waitForSwell();
        setSwellAPI(window.swellAPI);
      } catch (e) {
        console.error('Error fetching points:', e); // Use console.error for errors
      }
    };

    initializeSwell();

    // Observe mutations for the rewards element
    const observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i++) {
        const { addedNodes } = mutations[i];
        for (let j = 0; j < addedNodes.length; j++) {
          const node = addedNodes[j];
          if (node.nodeType === 1) { // Check for element nodes
            const foundElement = node.querySelector('.yotpo-product-points-widget-points-amount');
            if (foundElement) {
              setRewardsElement(foundElement);
              // Disconnect observer once the element is found to prevent unnecessary checks
              observer.disconnect();
              return;
            }
          }
        }
      }
    });

    observer.observe(containerRef.current, { childList: true, subtree: true });

    // Cleanup observer on component unmount
    return () => observer.disconnect();
  }, [customer?.tags]); // Depend only on customer.tags for this effect

  useEffect(() => {
    if (!customerTags || !swellAPI || !rewardsElement) return;

    const vipTiers = swellAPI.getVipTiers();
    const tierName = customerTags.replace('swell_vip_', '').toLowerCase();
    const customerVipTier = vipTiers.find((tier) => tier.name.toLowerCase() === tierName);
    let productPoints = parseInt(rewardsElement.textContent.replace(/\D/g, ''), 10);

    if (customerVipTier && customerVipTier.pointsMultiplier > 1 && !Number.isNaN(productPoints)) {
      const { pointsMultiplier } = customerVipTier;
      productPoints = Math.floor(productPoints * pointsMultiplier);
    }

    if (productPointsBlock?.widgetText) {
      rewardsElement.innerHTML = productPointsBlock.widgetText.replace('[points]', `<b>${productPoints}</b>`);
    }
  }, [customerTags, swellAPI, rewardsElement]); // Dependencies for this effect

  return <>{parse(yotpoRewardsMarkup)}</>;
};

export default Rewards;
